export const traceInterpolationIndices = (set, traceSet) => {
  const indices = [];
  let currentIndex = 0;

  if (set?.length !== traceSet?.length || set?.length < 1) {
    return [];
  }

  for (let i = 0; i < set.length; i++) {
    const currentSetItem = String(set[i] || '');
    const currentTraceItem = traceSet[i];

    if (currentTraceItem) {
      indices.push({
        start: currentIndex,
        end: currentIndex + currentSetItem.length,
        stepId: currentTraceItem.stepId,
        key: currentTraceItem.key,
        stringified: currentTraceItem.stringified
      });
    }

    currentIndex += currentSetItem ? currentSetItem.length : 0;
  }
  return indices;
};
